/* eslint-disable react/no-direct-mutation-state */


import React, { Component } from 'react';
import {Card} from 'reactstrap';
import { connect } from 'react-redux';

import HeaderComponent from '../header/header';
import MenuCategories from '../menu/category/categories';
import MenuItems from '../menu/items/items';
import ItemComponent from './itemComponent';
import BasketSummaryComponent from '../basket/basketSummary';
import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";

import { loadMenu as loadMenuFromServer } from "../../../../utils/api/menuApiProxy";

const basketUtil = require('../../../../utils/basket/basketUtil.js');
const stateManager = require('../../../../utils/state/stateManager.js');
const fatalErrorAction = require('../../../../utils/state/actions/error/fatalErrorAction');
const menuCategoryAction = require('../../../../utils/state/actions/menuCategory/menuCategoryAction');
const storeUtil = require('../../../../utils/store/storeUtil');

class Store extends Component 
{
    constructor(props)
    {
        super(props);
        this.state = {};

        this.state.isCategoryToolbarClicked = false;
        this.state.changedCategoryOnScrolling = false;
        
        this.state.lastScrollTop = 0;
        this.state.isScrollingUpDirection = false;
        
        this.state.itemDialogueItemCategoryIndex = -1;
        this.state.itemDialogueItemIndex = -1;
        this.state.adjustItemDialogueScrolling = false;
        this.state.scrollPositionBeforeItemDialogue = null;
      
        this.handleScroll = this.handleScroll.bind(this);
    }

    render()
    {
        return (
            <div>
                <Card style={{paddingTop:'30px', paddingBottom:'30px', background: `var(--header-background-color)`}}>
                    <HeaderComponent/>
                </Card>
                {this.renderMenu()}
                {this.renderItemDialogue()}
            </div>
        )
    }

    componentDidMount()
    {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount()
    {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(event)
    {
        if (this.state.adjustItemDialogueScrolling || this.state.scrollPositionBeforeItemDialogue != null)
            return;

        var currentMenu = stateManager.getStore().getState().currentMenu;

        if (currentMenu == null)
            return;

        this.state.isScrollingUpDirection = false;
        var st = window.pageYOffset || document.documentElement.scrollTop; 
        if (st > this.state.lastScrollTop) this.state.isScrollingUpDirection = true;
        this.state.lastScrollTop = st <= 0 ? 0 : st; 

        let nextIndex = 0;
        if (this.state.isScrollingUpDirection)
            nextIndex = this.findNextIndex(1);
        else
            nextIndex = this.findNextIndex(-1);
       
        if (nextIndex < 0 || nextIndex >= currentMenu.categories.length)
            return;
        
        let menuCategoryHeaderId = `menu-category-header-${nextIndex}`;
        var categoryHeaderElement = document.getElementById(menuCategoryHeaderId);

        if (this.isInViewport(categoryHeaderElement))
        {
            stateManager.getStore().dispatch(menuCategoryAction.createAction(nextIndex));
            this.state.changedCategoryOnScrolling = true;
            return;
        }  
    }

    findNextIndex (delta)
    {
        var currentMenu = stateManager.getStore().getState().currentMenu;
        let nextIndex = this.props.currentMenuCategoryIndex;

        while(true)
        {
            nextIndex = nextIndex + delta;
            if (nextIndex < 0 || nextIndex >= currentMenu.categories.length)
                return -1;

            let menuCategoryHeaderId = `menu-category-header-${nextIndex}`;
            var categoryHeaderElement = document.getElementById(menuCategoryHeaderId);
            if (categoryHeaderElement != null)
                return nextIndex;
        }
    }

    isInViewport(el) 
    {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    
        );
    }
  
    componentDidUpdate()
    {
        if (this.state.adjustItemDialogueScrolling)
        {
            window.scrollTo(0, 0);
            this.state.adjustItemDialogueScrolling = false;
            return;
        }

        if (this.state.scrollPositionBeforeItemDialogue != null)
        {
            window.scrollTo(0, this.state.scrollPositionBeforeItemDialogue);
            this.state.scrollPositionBeforeItemDialogue = null;
            return;
        }
        
        var currentMenu = stateManager.getStore().getState().currentMenu;
        if(currentMenu == null)
            return;

        let menuCategoryToolBarId = `menu-category-toolbar-${this.props.currentMenuCategoryIndex}`;
        if (this.state.isScrollingUpDirection)
        {
            if (this.props.currentMenuCategoryIndex+1 < currentMenu.categories.length)
                menuCategoryToolBarId = `menu-category-toolbar-${this.props.currentMenuCategoryIndex+1}`;
        }

        if (!this.state.isScrollingUpDirection)
        {
            if (this.props.currentMenuCategoryIndex-1 > 0)
                menuCategoryToolBarId = `menu-category-toolbar-${this.props.currentMenuCategoryIndex-1}`;
        }


        let menuCategoryHeaderId = `menu-category-header-${this.props.currentMenuCategoryIndex}`;
        var categoryToolBarElement = document.getElementById(menuCategoryToolBarId);
        var categoryHeaderElement = document.getElementById(menuCategoryHeaderId);

        if (this.state.isCategoryToolbarClicked && categoryHeaderElement != null)
        {
            this.state.isCategoryToolbarClicked = false;
            categoryHeaderElement.scrollIntoView(true,{behavior: "smooth", block: "start"});
        }

        if (this.state.changedCategoryOnScrolling && categoryToolBarElement != null)
        {
            this.state.changedCategoryOnScrolling = false;
            categoryToolBarElement.scrollIntoView(true,{behavior: "smooth",  block: 'start', inline: "start"});
        }
    }

    renderMenu()
    {
        var state = stateManager.getStore().getState();

        if (state.currentMenu == null)
        {
            return this.loadMenu();
                    
        }

        return  <div>
                    <MenuCategories onClick={(categoryIndex)=>{this.state.isCategoryToolbarClicked = true;}}/>
                    <div className='w-100 d-flex flex-row justify-content-start align-item-top'>
                        <div style={{width:"60%", marginTop:'20px'}}>
                            <MenuItems onClick={(categoryIndex, category, itemIndex, item) => 
                                                    {
                                                        this.state.itemDialogueItemCategoryIndex = categoryIndex;
                                                        this.state.itemDialogueItemIndex = itemIndex;

                                                        // this.state.adjustItemDialogueScrolling = true;
                                                        this.state.scrollPositionBeforeItemDialogue = window.pageYOffset;

                                                        this.setState({});
                                                    }}/>
                        </div>
                        <div style={{width:"40%"}}>
                            <BasketSummaryComponent/>
                        </div>
                    </div>                    
                </div>
    }

    renderItemDialogue()
    {
        if (this.state.itemDialogueItemIndex < 0)
            return null;

        return <ItemComponent 
                    categoryIndex={this.state.itemDialogueItemCategoryIndex} 
                    itemIndex = {this.state.itemDialogueItemIndex}
                    onClose={(orderItem)=>
                            {
                                this.state.itemDialogueItemCategoryIndex = -1;
                                this.state.itemDialogueItemIndex = -1;

                                if (orderItem != null)
                                    basketUtil.addItemToBasket(orderItem);

                                this.setState({});
                            }}
                />
    }

    loadMenu()
    {
        loadMenuFromServer()
        .then(response =>
            {
                basketUtil.resetMenu(response.saleMenu, response.rewardMenu);
                
            }, error =>
            {
                stateManager.getStore().dispatch(fatalErrorAction.createAction(error));
            });

        return <table width="100%">
                    <tr>
                        {this.getPlaceHolders(3)}
                    </tr>

                    <tr>
                        {this.getPlaceHolders(3)}
                    </tr>
                </table>
    }

    getPlaceHolders(times)
    {
        var placeHolders = [];
        for(var index = 0;index < times;index++)
        {
            placeHolders.push(
                <td width="33%" style={{paddingTop:'20px', paddingRight:'10px', paddingLeft: '10px'}}>
                    <Card style={{padding: '50px'}}>
                        <ReactPlaceholder showLoadingAnimation={true} type='media' rows={3} ready={false} color={`var(--skeleton-color)`} />
                    </Card>
                </td>
            )
        }
        return placeHolders;
    }
}

const mapStateToProps = state => 
{
    return { 
        basketVersion: state.basketVersion,
        currentMenuCategoryIndex: state.currentMenuCategoryIndex,
    }
}

export default connect(mapStateToProps)(Store)